export default __webpack_public_path__ + "static/elevators2-a93383fb4e03e2f3ac6620acc329717c.gif";